import { useDispatch } from "react-redux";
import { handleError } from "../redux/slice";

function ErrorAlert({ message }) {
  const dispatch = useDispatch();

  const onClose = (e) => {
    e.preventDefault();
    dispatch(handleError());
  };

  if (!message) return null;

  return (
    <div
      className="position-fixed top-0 start-50 translate-middle-x mt-3"
      style={{ zIndex: 1050, width: "auto", maxWidth: "90%", fontSize: "15px" }}
    >
      <div
        className="alert alert-danger alert-dismissible fade show mb-0"
        role="alert"
      >
        {message}
        <button type="button" className="btn-close" onClick={onClose}></button>
      </div>
    </div>
  );
}

export default ErrorAlert;
